<template>
  <div>
    <b-modal
      id="customer-agent-modal"
      centered
      hide-footer
      :title="$t('account.contactSalesConsultant')"
      header-text-variant="light"
      hide-header-close
      size="md"
    >
      <Input
        label="account.from"
        id="fullname"
        v-model="form.from"
        :defaultValue="user.fullname"
        readonly="readonly"
      />

      <Input
        label="account.to"
        id="fullname"
        v-model="form.to"
        :defaultValue="$t('account.salesConsultant')"
        readonly="readonly"
      />

      <Input
        label="global.title"
        id="title"
        :state="validateState('title')"
        v-model="form.title"
        :defaultValue="title"
      />

      <Textarea
        label="global.description"
        id="description"
        :state="validateState('description')"
        :placeholder="$t('account.salesConsultantMessage')"
        v-model="form.description"
        :defaultValue="description"
      />

      <div class="d-flex justify-content-end mt-5">
        <b-button
          type="reset"
          class="rounded-sm mr-3 btn-sm"
          variant="light"
          @click="closeModal"
          >{{ $t('global.cancel') }}</b-button
        >

        <b-button
          type="submit"
          class="rounded-sm btn-sm"
          variant="primary"
          @click="confirm()"
          >{{ $t('global.send') }}</b-button
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
// Utils
import ApiService from '@/core/services/api.service'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'CustomerAgentModal',
  mixins: [validationMixin],
  props: {
    user: Array | String,
    title: String,
    description: String,
  },
  data() {
    return {
      loading: false,
      form: {
        from: '',
        to: '',
        title: '',
        description: '',
      },
    }
  },
  validations: {
    form: {
      title: {
        required,
      },
      description: {
        required,
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    confirm() {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        return
      }
      this.loading = true

      let params = {
        category_ref: 'vyGNGgyNoW',
        priority: 'medium',
        title: this.form.title,
        body: this.form.description,
      }

      ApiService.post('support', params)
        .then(({ data }) => {
          this.$generateToast(this, 'success', this.$t('global.successful'))
        })
        .catch((err) => {
          this.$generateToast(this, 'danger', err.message, true)
        })
        .finally(() => {
          this.closeModal()
        })
    },
    closeModal() {
      this.form.title = ''
      this.form.description = ''
      this.$v.$reset()
      this.loading = false
      this.$bvModal.hide('customer-agent-modal')
    },
  },
}
</script>
